import { z } from 'zod';

export const invoiceSchema = z.object({
  netTrade: z.number(),
  invoiceTotal: z.number(),
  equipmentCost: z.number(),
  netFinanceAmount: z.number(),
  salesTaxOnInvoice: z.number(),
  tradeOwedBalanceAmount: z.number(),
  manufacturerRebateAmount: z.number(),
  freightLaborInstallation: z.number(),
  tradeAllowanceGrossTradeIn: z.number(),
  invoiceWarrantyAndInsuranceCharges: z.number(),
  downPayment: z.object({ flat: z.number(), percent: z.number() }),
});

export type InvoiceFormValues = z.infer<typeof invoiceSchema>;
